import { Box, Container, Typography } from "@mui/material";

import promiseBg from "../../assets/images/promise_bg.png";
import promiseBgm from "../../assets/images/promise_bg_m.png";
// import promiseCardBg from "../../assets/images/services_showcase_bg.png";
import promiseCardBg from "../../assets/images/promise_card_bg.png";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PaidIcon from "@mui/icons-material/Paid";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

const promises = [
  {
    title: "Fabric Safe Cleaning",
    desc: "Every garment is treated with the utmost care using professional cleaning methods.",
    icon: <VerifiedUserIcon />,
  },

  {
    title: "Transparent Pricing",
    desc: "No hidden fees, no surprises. Honest pricing for every service.",
    icon: <PaidIcon />,
  },

  {
    title: "Reliable Delivery",
    desc: "On-time pickup and delivery designed around your schedule.",
    icon: <LocalShippingIcon />,
  },

  {
    title: "Consistent Quality",
    desc: "Premium results every time, backed by experienced professionals.",
    icon: <WorkspacePremiumIcon />,
  },
];

export default function CustomerPromise() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        position: "relative",

        overflow: "hidden",

        backgroundImage: {
          xs: ` url(${promiseBgm})  `,
          md: ` url(${promiseBg})  `,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",
      }}
    >
      <Container maxWidth="xl">
        {/* HEADING */}

        <Box
          sx={{
            textAlign: "center",

            maxWidth: "900px",

            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(0,87,255,.08)",

              color: "#0057FF",

              fontSize: "12px",

              fontWeight: 800,

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            Customer Promise
          </Box>

          <Typography
            sx={{
              mt: 2,

              fontWeight: 900,

              lineHeight: 1.05,

              color: "#07122F",
              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
            }}
          >
            The Comet Cleaners
            <br />
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Promise
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,

              maxWidth: "700px",

              mx: "auto",

              color: "#64748B",

              lineHeight: 1.8,

              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            We believe exceptional service starts with trust, consistency and
            attention to detail.
          </Typography>
        </Box>

        {/* CARDS */}

        <Box
          sx={{
            mt: {
              xs: 4,
              md: 6,
            },

            display: "flex",

            flexWrap: {
              xs: "wrap",
              lg: "nowrap",
            },

            justifyContent: "space-between",

            gap: {
              xs: 1.5,
              md: 2,
            },
          }}
        >
          {promises.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "0 0 calc(50% - 6px)",
                  lg: "1",
                },

                maxWidth: {
                  xs: "calc(50% - 6px)",
                  lg: "none",
                },

                minHeight: {
                  xs: 150,
                  sm: 170,
                  md: 190,
                },

                p: {
                  xs: 1.5,
                  md: 2,
                },

                position: "relative",

                overflow: "hidden",

                borderRadius: {
                  xs: "18px",
                  md: "24px",
                },

                backgroundImage: `
        //   linear-gradient(
        //   rgba(255,255,255,.92),
        //   rgba(248,251,255,.86)
        //   ),
          url(${promiseCardBg})
        `,

                backgroundSize: "cover",

                backgroundPosition: "center",

                border: "1px solid rgba(255,255,255,.85)",

                boxShadow:
                  "0 12px 35px rgba(0,87,255,.08), inset 0 1px 0 rgba(255,255,255,.9)",

                transition: ".35s",

                "&::before": {
                  content: '""',

                  position: "absolute",

                  left: 0,

                  top: 14,

                  bottom: 14,

                  width: "4px",

                  borderRadius: "20px",

                  background: "linear-gradient(180deg,#0057FF,#1DB6FF,#0057FF)",
                },

                "&::after": {
                  content: '""',

                  position: "absolute",

                  inset: 0,

                  background:
                    "linear-gradient(135deg,rgba(255,255,255,.15),transparent)",

                  pointerEvents: "none",
                },

                "&:hover": {
                  transform: "translateY(-6px)",

                  boxShadow: "0 25px 60px rgba(0,87,255,.14)",

                  "&::before": {
                    width: "6px",
                  },
                },
              }}
            >
              {/* ICON */}

              <Box
                sx={{
                  width: {
                    xs: 40,
                    md: 50,
                  },

                  height: {
                    xs: 40,
                    md: 50,
                  },

                  borderRadius: "14px",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  color: "#fff",

                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  border: "2px solid rgba(255,255,255,.5)",

                  boxShadow: "0 12px 30px rgba(0,87,255,.25)",

                  mb: 1.5,

                  "& svg": {
                    fontSize: {
                      xs: 18,
                      md: 24,
                    },
                  },
                }}
              >
                {item.icon}
              </Box>

              {/* TITLE */}

              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#07122F",

                  lineHeight: 1.2,

                  fontSize: {
                    xs: "13px",
                    md: "18px",
                  },
                }}
              >
                {item.title}
              </Typography>

              {/* DESCRIPTION */}

              <Typography
                sx={{
                  mt: 1,

                  color: "#64748B",

                  lineHeight: 1.5,

                  fontSize: {
                    xs: "10px",
                    md: "13px",
                  },
                }}
              >
                {item.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
